import { render } from "./glossary.vue?vue&type=template&id=519fb198&ts=true"
import script from "./glossary.vue?vue&type=script&lang=ts"
export * from "./glossary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__